import { SendType } from "@/common/stores/nonpersistingStores/currentInteraction";
import { Resource } from ".";

export interface Queue {
	id: string;
	name: string;
	type: QueueType;
	isAttached: boolean;
	canJoin: boolean;
	isSupervisor: boolean;
	isOperator: boolean;
	hasParkingRight: boolean;
	hasAllInteractionVisibilityRight: boolean;
	hasAgentsActivityRight: boolean;
	hasOutboundRight: boolean;
	isEmailSubjectEditEnabled: boolean;
	isPreviewModeEnabled: boolean;
	isPickupEnabled: boolean;
	emailSendType: SendType;
	isSkillBasedRoutingEnabled: boolean;
	enableRecording?: boolean;
	autoStartRecording?: boolean;
	enableTranscription?: boolean;
	autoStartTranscription?: boolean;
	enableCallSummary?: boolean;
	autoInsertCallSummary?: boolean;
	enableTextSummary?: boolean;
	autoInsertTextSummary?: boolean;
}

export interface QueueFlags {
	isPreviewModeEnabled: boolean;
	isPickupEnabled: boolean;
	emailSendType: SendType;
}

export interface QueueWithResources {
	id: string;
	name: string;
	resources: Resource[];
}

export enum QueueType {
	Voice = 0,
	Operator = 1,
	Messaging = 2,
}

export interface QueueChanged {
	id: string;
	name: string;
	offerCallsToAgentsWithoutClient: boolean;
}

export interface AgentWorkloadNotification {
	agentId: string;
	totalWorkload: number;
	triggeredBySupervisorRefresh: boolean;
}

export interface CallSentimentChangedDto {
	sessionId: string;
	agentId: string;
	queueId: string;
	overallSentiment: number;
}

export interface SupervisorQueuesData {
	showStatusTimer: boolean;
	queues: SupervisedQueue[];
}

export interface SupervisedQueue {
	id: string;
	name: string;
	type: QueueType;
	offerCallsToAgentsWithoutClient: boolean;
	averageEstimatedWaitTime: string;
	definedEstimatedWaitTime: string;
	useDefinedEstimatedWaitTime: boolean;
	isJoined: boolean;
	desire: number;
	agentId: string;
	isSimultaneousOfferingEnabled: boolean;
}

export interface SupervisedQueues {
	agentId: string;
	queueIds: string[];
	type?: QueueType;
	isJoined: boolean;
}
